// @see https://sunstonecreditinc.atlassian.net/browse/SUNENG-2205
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import {
  RulesetResult,
  IsPGLoan,
  IsApplicantSameAsPrincipal,
  HasPgFiledTaxesYearsAgo,
} from '../rules';

class PgTaxes3YearsAgoRuleset implements Ruleset {
  private principalId: any;

  public setPrincipalId(id: any) {
    this.principalId = id;
    return this;
  }
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const isPGLoan = IsPGLoan.evaluate(data);
    const applicantSameAsPrincipal = IsApplicantSameAsPrincipal.setPrincipalId(
      this.principalId
    ).evaluate(data);
    const hasPgNotFiledTaxes1YearAgo = HasPgFiledTaxesYearsAgo.setPrincipalId(
      this.principalId
    )
      .setYears(1)
      .setAnswer('No')
      .evaluate(data);

    const hasPgNotFiledTaxes2YearsAgo = HasPgFiledTaxesYearsAgo.setPrincipalId(
      this.principalId
    )
      .setYears(2)
      .setAnswer('No')
      .evaluate(data);

    const hasPgFiledTaxes3YearsAgo = HasPgFiledTaxesYearsAgo.setPrincipalId(
      this.principalId
    )
      .setYears(3)
      .setAnswer('Yes')
      .evaluate(data);

    const hasPGFiledTaxes3YearsAgoNotAnswered =
      HasPgFiledTaxesYearsAgo.setPrincipalId(this.principalId)
        .setYears(3)
        .setAnswer(null)
        .evaluate(data);

    return isPGLoan &&
      applicantSameAsPrincipal &&
      ((hasPgNotFiledTaxes1YearAgo &&
        hasPgNotFiledTaxes2YearsAgo &&
        hasPgFiledTaxes3YearsAgo) ||
        (hasPgNotFiledTaxes1YearAgo &&
          hasPgNotFiledTaxes2YearsAgo &&
          hasPGFiledTaxes3YearsAgoNotAnswered))
      ? RulesetResult.REQUIRED
      : RulesetResult.HIDDEN;
  };
}

export default new PgTaxes3YearsAgoRuleset();
